export class AuthError extends Error {
  constructor() {
    super('Authentication required');
  }
}
